import { Invoice } from '../types/invoice.type';

/** Build ancestor chain from root to the given folder using parent_id links. */
export function buildFolderBreadcrumb(
  folderId: string | undefined,
  allFolders: Invoice[]
): Invoice[] {
  if (!folderId) return [];

  const byId = new Map(allFolders.map((folder) => [folder.id, folder]));
  const path: Invoice[] = [];
  const visited = new Set<string>();
  let cursor: string | undefined = folderId;

  while (cursor && !visited.has(cursor)) {
    visited.add(cursor);
    const folder = byId.get(cursor);
    if (!folder) break;
    path.unshift(folder);
    cursor = folder.parent_id;
  }

  return path;
}

export function getParentFolderId(
  folderId: string | undefined,
  allFolders: Invoice[]
): string | undefined {
  if (!folderId) return undefined;
  return allFolders.find((folder) => folder.id === folderId)?.parent_id;
}
